// (A) 중립 툴팁 API — antd 미접촉. (B) PlainTooltip(Radix) 에 위임.
import type { ReactNode } from 'react'
import { PlainTooltip } from '../_impl/PlainTooltip'

export type OmwTooltipPlacement =
  | 'top'
  | 'bottom'
  | 'left'
  | 'right'
  | 'topLeft'
  | 'topRight'
  | 'bottomLeft'
  | 'bottomRight'
  | 'leftTop'
  | 'leftBottom'
  | 'rightTop'
  | 'rightBottom'

export type OmwTooltipTrigger = 'hover' | 'focus' | 'click' | 'contextMenu'

export interface OmwTooltipProps {
  title: ReactNode
  placement?: OmwTooltipPlacement
  zIndex?: number
  /** 화살표 표시 여부. antd 기본 true. */
  arrow?: boolean
  /** 표시 트리거. antd 기본 'hover'. */
  trigger?: OmwTooltipTrigger | OmwTooltipTrigger[]
  className?: string
  children: ReactNode
}

export function OmwTooltip(props: OmwTooltipProps) {
  return <PlainTooltip {...props} />
}
